import { render } from "./ArticleShow.vue?vue&type=template&id=10374350"
import script from "./ArticleShow.vue?vue&type=script&lang=js"
export * from "./ArticleShow.vue?vue&type=script&lang=js"

import "./ArticleShow.vue?vue&type=style&index=0&id=10374350&lang=scss"
import "./ArticleShow.vue?vue&type=style&index=1&id=10374350&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__